import getDefaultState from './state';

export function flush(state) {
  Object.assign(state, getDefaultState());
}

export function updateProductTrails(state, { productTrails }) {
  state.productTrails = productTrails;
}

export function updateFilter(state, { filter }) {
  state.filter = filter;
}

export function updateMeta(state, { meta }) {
  state.meta = meta;
}

export function updateSort(state, { sort }) {
  state.sort = sort;
}
